import * as React from 'react';

import * as ReactDOM from 'react-dom';

import { updateTokenFromCookie, updateTokenFromUrlHash, updateTokenFromUrlParams } from 'common/helpers/jwtHelper';
import type { TrackedError } from 'ErrorBoundary/Error';
import { shouldIgnoreError, isBoundaryError } from 'ErrorBoundary/Error';
import { showErrorBoundarySubject } from 'ErrorBoundary/ErrorBoundary';
import 'react-app-polyfill/stable';

import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import './index.scss';

/**
 * Gets JWT from URL if it is provided and updates it's value in local storage.
 * We keep the hasTokenInCookie as it will indicate whether the login mutation should be fired.
 */
const hasToken =
  updateTokenFromCookie() || // Try and get the token from the cookie
  updateTokenFromUrlParams() || // If there is set cookie, try and get the token from the url search
  updateTokenFromUrlHash(); // Finally try and get from the has portion.

ReactDOM.render(<App shouldLogin={hasToken} />, document.getElementById('root') as HTMLElement);

window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
  const error = e && (e.reason as TrackedError);

  if (shouldIgnoreError(error)) {
    // null indicates that event will be disposed of
    return null;
  }

  if (!isBoundaryError(error)) {
    showErrorBoundarySubject.next({ event: undefined, hint: { originalException: error } });
  }

  return error;
});

serviceWorkerRegistration.unregister();
